import apiClient from "./APIClient";

export const getSocialProducts = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('lang', 'en');
    
    if (filters.countryId) {
      params.append('countryId', filters.countryId);
    }
    if (filters.productCategoryId) {
      params.append('productCategoryId', filters.productCategoryId);
    }
    if (filters.productTypeId) {
      params.append('productTypeId', filters.productTypeId);
    }
    if (filters.search) {
      params.append('search', filters.search);
    }
    
    const res = await apiClient.get(`/product/agent/social?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching social products:", error);
    throw error;
  }
};

export const activateSocialProduct = async (payload) => {
  try {
    const res = await apiClient.post(`/social/agent?lang=en`, payload);
    return res.data;
  } catch (error) {
    console.error("Error activating social product:", error);
    throw error;
  }
};

export const getAgentSocialOrders = async (userId, filters = {}) => {
  try {
    const params = new URLSearchParams();
    
    // Add filters
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const res = await apiClient.get(`/social/orders?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching social orders:", error);
    throw error;
  }
};

export const getSocialProductCategories = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('lang', 'en');
    
    if (filters.search) {
      params.append('search', filters.search);
    }
    
    const res = await apiClient.get(`/productCategory/social/all?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching social product categories:", error);
    throw error;
  }
};

export const getSocialProductTypes = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    params.append('lang', 'en');
    
    if (filters.search) {
      params.append('search', filters.search);
    }
    
    const res = await apiClient.get(`/productTypes/social/all?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching social product types:", error);
    throw error;
  }
};

export const getCountries = async () => {
  try {
    const res = await apiClient.get('/country?lang=en');
    return res.data;
  } catch (error) {
    console.error("Error fetching countries:", error);
    throw error;
  }
};